import React from 'react';
import { TextInput, TranslatableInputs } from 'react-admin';
import { PendingField } from './PendingField';
import { RichTextInput } from 'ra-input-rich-text';
import RewriteableEditor from './RewriteableEditor';
import { CkEditorInput } from '../Inputs/CkEditorInput';
import {
  validateSeoDescription,
  validateSeoKeywords,
  validateSeoTitle,
  validateKeywords,
} from '../../validators/common';

const ContentTranslations = ({ lockedFields, children, ...props }) => (
  <TranslatableInputs {...props}>
    {React.Children.map(children, child => React.isValidElement(child) && child.props.source
      ? <PendingField lockedFields={lockedFields}>{child}</PendingField> : child)}
  </TranslatableInputs>
);

export const CourseContentInputs = ({ seo = false, locales = ['de'], lockedFields = [] }) => {
  const DescriptionEditor = seo ? CkEditorInput : RewriteableEditor;
  return (
    <ContentTranslations
      lockedFields={lockedFields}
      locales={locales}
      defaultLocale={locales.includes('de') ? 'de' : locales[0]}
      groupKey="translations"
    >
      <TextInput
        required
        fullWidth
        label={'Title'}
        source="translationsFormView.title"
        id="translationsFormView.title"
        format={(v) => (v ? v : '')}
      />
      <TextInput
        fullWidth
        label={'Subtitle'}
        source="translationsFormView.subtitle"
        id="translationsFormView.subtitle"
        format={(v) => (v ? v : '')}
      />
      <DescriptionEditor
        multiline
        rows={3}
        label={'Description'}
        source="translationsFormView.description"
        id="translationsFormView.description"
      />
      <DescriptionEditor
        multiline
        rows={3}
        label={'Long description'}
        source="translationsFormView.descriptionLong"
        id="translationsFormView.descriptionLong"
      />
      <DescriptionEditor
        multiline
        rows={3}
        label={'Short Description'}
        source="translationsFormView.descriptionShort"
        id="translationsFormView.descriptionShort"
      />
      <RichTextInput
        label={'Short Description In List'}
        source="translationsFormView.descriptionShortForList"
        id="translationsFormView.descriptionShortForList"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        label={'Other Locations'}
        source="translationsFormView.otherLocations"
        id="translationsFormView.otherLocations"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <TextInput
        fullWidth
        label={'Teaching Type'}
        source="translationsFormView.teachingType"
        id="translationsFormView.teachingType"
      />
      <TextInput
        fullWidth
        label={'Execution Type'}
        source="translationsFormView.executionType"
        id="translationsFormView.executionType"
      />
      <RichTextInput
        stripTags
        label={'Requirements'}
        source="translationsFormView.requirements"
        id="translationsFormView.requirements"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        fullWidth
        label={'Subsidy'}
        source="translationsFormView.subsidy"
        id="translationsFormView.subsidy"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        label={'Subsidy Short'}
        source="translationsFormView.subsidyShort"
        id="translationsFormView.subsidyShort"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        stripTags
        label={'Certification Content'}
        source="translationsFormView.certificationContent"
        id="translationsFormView.certificationContent"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        stripTags
        label={'Target Group'}
        source="translationsFormView.targetGroup"
        id="translationsFormView.targetGroup"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <TextInput
        fullWidth
        label={'Target Group Short'}
        source="translationsFormView.targetGroupShort"
        id="translationsFormView.targetGroupShort"
      />
      <RichTextInput
        stripTags
        label={'Objectives'}
        source="translationsFormView.objectives"
        id="translationsFormView.objectives"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        stripTags
        label={'Exam'}
        source="translationsFormView.exam"
        id="translationsFormView.exam"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        stripTags
        label={'Documents'}
        source="translationsFormView.documents"
        id="translationsFormView.documents"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        stripTags
        label={'Content'}
        source="translationsFormView.content"
        id="translationsFormView.content"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        label={'Ausbildung Info'}
        source="translationsFormView.ausbildungInfo"
        id="translationsFormView.ausbildungInfo"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        label={'Ausbildung Faq'}
        source="translationsFormView.ausbildungFaq"
        id="translationsFormView.ausbildungFaq"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        label={'Ausbildung Additional Service'}
        source="translationsFormView.ausbildungAdditionalService"
        id="translationsFormView.ausbildungAdditionalService"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        label={'Ausbildung After'}
        source="translationsFormView.ausbildungAfter"
        id="translationsFormView.ausbildungAfter"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        label={'Education Graduation Title'}
        source="translationsFormView.educationGraduationTitle"
        id="translationsFormView.educationGraduationTitle"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        label={'Education Teaching Time'}
        source="translationsFormView.educationTeachingTime"
        id="translationsFormView.educationTeachingTime"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        label={'Education Promotion'}
        source="translationsFormView.educationPromotion"
        id="translationsFormView.educationPromotion"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        label={'Education Space'}
        source="translationsFormView.educationSpace"
        id="translationsFormView.educationSpace"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        label={'Education Labour Market Chances'}
        source="translationsFormView.educationLabourMarketChances"
        id="translationsFormView.educationLabourMarketChances"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <RichTextInput
        label={'Education Ratio'}
        source="translationsFormView.educationRatio"
        id="translationsFormView.educationRatio"
        format={(v) => (v ? v : '')}
        parse={(v) => (v === '<p><br></p>' || v === '<p></p>' || !v ? '' : v)}
      />
      <TextInput
        fullWidth
        // stripTags
        label={'Keywords'}
        source="translationsFormView.keywords"
        id="translationsFormView.keywords"
        validate={validateKeywords}
      />
      <TextInput
        fullWidth
        label={'Seo Title'}
        source="translationsFormView.seoTitle"
        id="translationsFormView.seoTitle"
        validate={validateSeoTitle}
        format={(v) => (v ? v : '')}
      />
      <TextInput
        fullWidth
        multiline
        label={'Seo Description'}
        rows={3}
        source="translationsFormView.seoDescription"
        id="translationsFormView.seoDescription"
        validate={validateSeoDescription}
        format={(v) => (v ? v : '')}
      />
      <TextInput
        fullWidth
        multiline
        rows={3}
        label={'Seo Keywords'}
        source="translationsFormView.seoKeywords"
        id="translationsFormView.seoKeywords"
        validate={validateSeoKeywords}
        format={(v) => (v ? v : '')}
      />
      <TextInput
        fullWidth
        label={'Education Subsidy'}
        source="translationsFormView.educationSubsidy"
        id="translationsFormView.educationSubsidy"
        format={(v) => (v ? v : '')}
      />
      <TextInput
        fullWidth
        label={'Exam Codes'}
        source="translationsFormView.examCodes"
        id="translationsFormView.examCodes"
        format={(v) => (v ? v : '')}
      />
      <TextInput
        fullWidth
        label={'Edu Goal'}
        source="translationsFormView.eduGoal"
        id="translationsFormView.eduGoal"
        format={(v) => (v ? v : '')}
      />
      <TextInput
        fullWidth
        label={'Graduation Type'}
        source="translationsFormView.graduationType"
        id="translationsFormView.graduationType"
        format={(v) => (v ? v : '')}
      />
      <TextInput
        fullWidth
        label={'Show Until Text'}
        source="translationsFormView.showUntilText"
        id="translationsFormView.showUntilText"
        format={(v) => (v ? v : '')}
      />
      <TextInput
        fullWidth
        label={'Requirements short'}
        source="translationsFormView.requirementsShort"
        id="translationsFormView.requirementsShort"
      />
      <TextInput
        fullWidth
        label={'Salary'}
        source="translationsFormView.salary"
        id="translationsFormView.salary"
      />
      {!seo && (
        <TextInput
          fullWidth
          label={'Vacancies'}
          source="translationsFormView.vacancies"
          id="translationsFormView.vacancies"
        />
      )}
      {seo && (
        <TextInput fullWidth label="Slug" source="translationsFormView.slug" />
      )}
      {seo && (
        <TextInput
          fullWidth
          label="Title pattern"
          source="translationsFormView.reviewsByTitle"
        />
      )}
    </ContentTranslations>
  );
};
